import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/empresas.css";
import EmpresasSummary from "../components/EmpresasSummary";
import EmpresasFilters from "../components/EmpresasFilters";
import EmpresasTable from "../components/EmpresasTable";
import EmpresaFormModal from "../components/EmpresaFormModal";
import { usePermissions } from "../../../../utils/permissions";

export default function EmpresasView({
  loading,
  error,
  resumen,
  filtros,
  setFiltros,
  limpiarFiltros,
  lastUpdated,
  page,
  pageSize,
  setPageSize,
  totalPages,
  total,
  goToPage,
  empresasPaginadas,
  seleccionado,
  seleccionar,
  reload,
  form,
}) {
  const { hasPermission } = usePermissions();
  const canCreate = hasPermission("empresas.crear");
  const canUpdate = hasPermission("empresas.actualizar");
  const canDelete = hasPermission("empresas.eliminar");

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (form.modal) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [form.modal]);

  const quickFilter = (key) => {
    switch (key) {
      case "activas":
        setFiltros((prev) => ({ ...prev, activo: "1", tipo: "all" }));
        break;
      case "inactivas":
        setFiltros((prev) => ({ ...prev, activo: "0", tipo: "all" }));
        break;
      case "internas":
        setFiltros((prev) => ({ ...prev, tipo: "interna", activo: "all" }));
        break;
      case "proveedores":
        setFiltros((prev) => ({ ...prev, tipo: "proveedor", activo: "all" }));
        break;
      case "externas":
        setFiltros((prev) => ({ ...prev, tipo: "externa", activo: "all" }));
        break;
      default:
        setFiltros((prev) => ({ ...prev, activo: "all", tipo: "all" }));
        break;
    }
  };

  const activeQuickFilter =
    filtros?.activo === "1"
      ? "activas"
      : filtros?.activo === "0"
        ? "inactivas"
        : filtros?.tipo === "interna"
          ? "internas"
          : filtros?.tipo === "proveedor"
            ? "proveedores"
            : filtros?.tipo === "externa"
              ? "externas"
              : "total";

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronizacion inicial";

  return (
    <section className="management-page management-theme-teal empresas-wrapper">
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Operativo / Empresas</p>
          <h4 className="management-title mb-1 d-flex align-items-center gap-2">
            <i className="bi bi-buildings" />
            Gestion de empresas
          </h4>
          <p className="text-muted mb-0">
            Administra las empresas asociadas, proveedores y aliados.
          </p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          {canCreate && (
            <button type="button" className="btn management-btn-primary" onClick={form.abrirCrear}>
              <i className="bi bi-plus-circle me-2" />
              Nueva empresa
            </button>
          )}
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <EmpresasSummary resumen={resumen} onQuickFilter={quickFilter} activeKey={activeQuickFilter} />

      <EmpresasFilters filtros={filtros} setFiltros={setFiltros} limpiarFiltros={limpiarFiltros} />

      <EmpresasTable
        empresas={empresasPaginadas}
        loading={loading}
        error={error}
        seleccionadoId={seleccionado?.id}
        onSelect={seleccionar}
        onEdit={canUpdate ? form.abrirEditar : undefined}
        onDelete={canDelete ? form.abrirEliminar : undefined}
        canEdit={canUpdate}
        canDelete={canDelete}
        reload={reload}
      />

      <div className="management-card d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="text-muted small">
          Mostrando {total === 0 ? 0 : (page - 1) * pageSize + 1}-{Math.min(total, page * pageSize)} de {total}
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <select
            className="form-select form-select-sm"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value) || 10);
              goToPage(1);
            }}
          >
            {[10, 25, 50].map((size) => (
              <option key={size} value={size}>
                {size} por pagina
              </option>
            ))}
          </select>
          <div className="btn-group">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToPage(page - 1)}
              disabled={page <= 1}
            >
              <i className="bi bi-chevron-left" />
            </button>
            <button className="btn btn-outline-secondary btn-sm" disabled>
              Pagina {page} / {totalPages}
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToPage(page + 1)}
              disabled={page >= totalPages}
            >
              <i className="bi bi-chevron-right" />
            </button>
          </div>
        </div>
      </div>

      <EmpresaFormModal {...form} />
    </section>
  );
}